import { useTranslation } from "react-i18next";
import Button from "./Button";
import { useRecoEngineActions } from "../hooks";

interface FeedbackRowProps {
  options?: Array<string>;
  disabled?: boolean;
}

const FeedbackRow = ({ options, disabled }: FeedbackRowProps) => {
  const [t] = useTranslation("translations");

  const { newQuery, 
    endQuery, 
    refineQuery 
  } = useRecoEngineActions();

  return (
     <div className="recoEngine__row feedbackRow">
         {options.map((option) => {
            switch (option) {
              case "end":
                return (
                  <Button key={option} onClick={endQuery} className="feedback" text={t("RecoSearch.end_query_user")} disabled={disabled} />
                );
              case "refine":
                return (
                  <Button key={option} onClick={refineQuery} className="feedback" text={t("RecoSearch.refine_query_user")} disabled={disabled} />
                );
              case "new":
                return (
                  <Button key={option} onClick={newQuery} className="feedback" text={t("RecoSearch.new_query_user")} disabled={disabled} />
                );
              default:
                return null;
            }
          })}
     </div>
  )
}

export default FeedbackRow;
